import { GridCellProps, GridColumnProps } from '@progress/kendo-react-grid'
import { formatLocalDateUTC } from 'utils/date'

export interface GridColumn extends GridColumnProps {
  show: boolean
  width?: number
}

const transactionWalletOverviewColumn: GridColumn[] = [
  {
    title: 'Reference',
    width: 180,
    minResizableWidth: 180,
    field: 'referenceId',
    show: true,
    filterable: false,
    filter: 'text',
  },
  {
    title: 'Type',
    width: 180,
    minResizableWidth: 180,
    field: 'type.name',
    show: true,
    filter: 'text',
  },
  {
    title: 'Client',
    show: true,
    field: 'client',
    children: [
      {
        title: 'Wallet',
        width: 180,
        minResizableWidth: 180,
        field: 'wallet.name',
        filter: 'text',
      },
      {
        title: 'Amount',
        width: 180,
        minResizableWidth: 180,
        field: 'amount',
        filter: 'numeric',
      },
      {
        title: 'Currency',
        width: 180,
        minResizableWidth: 180,
        field: 'currency.id',
        filter: 'text',
      },
    ],
  },
  {
    title: 'Status',
    width: 120,
    minResizableWidth: 120,
    field: `state.name`,
    show: true,
    filterable: true,
    filter: 'text',
  },
  {
    title: 'Payment Provider',
    show: true,
    field: 'paymentProvider',
    children: [
      {
        title: 'Name',
        width: 180,
        minResizableWidth: 180,
        field: 'paymentProvider.name',
        filter: 'text',
      },
      {
        title: 'Amount',
        width: 180,
        minResizableWidth: 180,
        field: 'paymentProviderAmount',
        filter: 'numeric',
      },
      {
        title: 'Currency',
        width: 180,
        minResizableWidth: 180,
        field: 'paymentProviderCurrency.id',
      },
    ],
  },
  {
    title: 'Date Created',
    width: 150,
    minResizableWidth: 150,
    field: 'createdDate',
    show: true,
    cell: (props: GridCellProps) => (
      <td className='clients-table-columns__date'>
        {formatLocalDateUTC(props.dataItem.createdDate, true)}
      </td>
    ),
    filterable: false,
  },
]

export default transactionWalletOverviewColumn
